export default function getCurrentWeekNumFromWeeklyTable(weekMasterData) {

    // let currentWeekNumber = 0;
    const today = new Date();

    const monthList = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",];

    for (let i = 0; i < weekMasterData?.length - 1; i++) {
        const curr = weekMasterData[i];
        const next = weekMasterData[i + 1];

        const [currDay, currMon] = curr.dates.split("-");
        const [nextDay, nextMon] = next.dates.split("-");

        const currDate = new Date(today.getFullYear(), monthList.indexOf(currMon), parseInt(currDay));
        const nextDate = new Date(today.getFullYear(), monthList.indexOf(nextMon), parseInt(nextDay));

        if (today >= currDate && today < nextDate) {
            return curr.wk_no;
        }
    }

    // Fallback: use last week's number or 1
    return weekMasterData[weekMasterData?.length - 1]?.wk_no || 1;
}